import store from '../../../../store'
import create_memorandum from './create_memorandum.vue';


window.MEMORANDUM_CREATE =  new Vue({
	store,
	el: '#memorandum_create',
	name : "MEMORANDUM_CREATE",
	data () {
		return {
			showModal: false,
		}
	},
	created () {

	},
	components : {
		create_memorandum
	}
})
